import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="border-t mt-auto">
      <div className="container mx-auto px-6 py-4">
        <div className="flex flex-wrap justify-center gap-4 text-sm text-muted-foreground">
          <Link to="/disclaimer" className="hover:text-primary">
            Medical Disclaimer
          </Link>
          <Link to="/privacy-policy" className="hover:text-primary">
            Privacy Policy
          </Link>
          <Link to="/terms" className="hover:text-primary">
            Terms of Service
          </Link>
        </div>
        <div className="text-center mt-2 text-xs text-muted-foreground">
          © {new Date().getFullYear()} Knowledge House Publishers Inc. All Rights Reserved.
        </div>
        <div className="text-xs text-muted-foreground mt-4 max-w-4xl mx-auto text-center">
          Disclaimer: The contents of this Website are based exclusively upon the opinions of Dr. Cass Ingram, unless otherwise noted. Individual articles are based upon the opinions of Dr. Cass Ingram, who retains copyright, as marked. The information on this Website is not intended to replace an in-person or otherwise relationship with a qualified health care professional and is not intended as medical advice. Rather, it is intended as a means of sharing and exchanging knowledge and information from the research and experience of Ingram and colleagues. Dr. Ingram encourages you to make your own health-related decisions based upon your research and in partnership with a qualified health care professional.
        </div>
      </div>
    </footer>
  );
};